const style = (theme) => {
  const transition = `all 1s ${theme.easings['power4.out']}`

  const output = {
    root: {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zindex.header,
      background: 'transparent',
      transition: `all 0.5s ${theme.easings.garret}`,
      pointerEvents: 'none',
    },
    rootBackground: {
    },
    container: {
      margin: '0 auto',
      paddingTop: theme.header.padding,
      paddingBottom: theme.header.padding,
      paddingLeft: '4.15vw',
      paddingRight: '4.15vw',
      marginLeft: -30,
      marginRight: -30,
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      transition,
    },
    logo: {
      fill: theme.colors[0],
      zIndex: 1,
      pointerEvents: 'all',
    },
    burger: {
      marginRight: 30,
      pointerEvents: 'all',
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'all',
      height: '100%',
    },
    burgerButton: {
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 60,
      height: 60,
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 'calc(50% - 30px)',
        left: 'calc(50% - 30px)',
        backgroundColor: theme.colors[1],
        borderRadius: '50%',
        boxShadow: '3px 3px 12px 6px rgba(0,0,0,0.03)',
        transition: 'all 0.45s cubic-bezier(.17,.67,.3,1.33)' },
      '@media (hover: hover)': {
        '&:hover': {
          '&::before': {
            transform: 'scale(1.15)',
          },
        },
      },
    },
    hide: {
      opacity: 0,
      pointerEvents: 'none',
    },
    payOff: {},
    wrapperBurgerLogo: {
      display: 'flex',
      alignItems: 'center',
    },
    btn: {
      pointerEvents: 'all',
    },
    noHeader: {
      opacity: 0,
      pointerEvents: 'none',
      zIndex: 1,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    lang: {
      marginLeft: 50,
    },
    container: {
      paddingLeft: 30,
      paddingRight: 30,
      marginLeft: 0,
      marginRight: 0,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    payOff: {
      display: 'none',
    },
    // left: {
    //   order: 998,
    //   marginLeft: 'auto',
    //   marginRight: 15,
    // },
    burger: {
      // order: 999,
      transform: 'translateX(-16px)',
    },
    // back: {
    //   width: 40,
    //   height: 40,
    //   background: theme.getRgba(theme.colors[4], 0.25),
    //   borderRadius: '50%',
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'center',
    //   '& span': {
    //     display: 'none',
    //   },
    // },
    // backArrow: {
    //   marginRight: 0,
    // },
    // lang: {
    //   display: 'inline-block',
    //   position: 'absolute',
    //   zIndex: 1,
    //   top: 'calc(50% - 14px)',
    //   left: 20,
    //   marginLeft: 0,
    //   color: () => theme.colors[3],
    // },
    // burgerLabel: {
    //   display: 'none',
    // },
    // logo: {
    //   position: 'relative',
    //   left: 'auto',
    //   '& svg': {
    //     width: '100%',
    //   },
    // },
    btn: {
      display: 'none',
    },
    wrapperBurgerLogo: {
      width: '100%',
      justifyContent: 'space-between',
    },
    wrapper: {
      // width: '100%',
    },
  }

  return output
}

export default style
